import {
  Create,
  email,
  ListButton,
  PasswordInput,
  required,
  SaveButton,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
  usePermissions,
} from "react-admin";

import {
  UserRole,
  USER_ROLES_OPTIONS_ALLOWED_TO_ADD_VIA_ADMIN_PANEL,
} from "@/constants/roles";
import { UserGroupArrayInput } from "@/inputs/UserGroupArrayInput";
import { equalPasswords, formatObjectsToArrayOfIds } from "@/utils";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const UserCreate = () => {
  const { permissions } = usePermissions<UserRole[]>();

  return (
    <Create actions={<CreateActions />} redirect="list">
      <SimpleForm toolbar={<CreateToolbar />}>
        <TextInput
          source="username"
          helperText="example: John"
          placeholder="Enter Name"
          validate={required()}
        />
        <TextInput
          type="email"
          source="email"
          validate={[required(), email()]}
          helperText="example: temp@domain.com"
          placeholder="Enter Email"
        />
        <UserGroupArrayInput
          source="groups"
          format={formatObjectsToArrayOfIds}
        />
        <SelectArrayInput
          source="roles"
          disabled={!permissions?.includes(UserRole.ADMIN)}
          choices={USER_ROLES_OPTIONS_ALLOWED_TO_ADD_VIA_ADMIN_PANEL}
        />
        <PasswordInput source="plainPassword" validate={required()} />
        <PasswordInput source="confirmPassword" validate={equalPasswords} />
      </SimpleForm>
    </Create>
  );
};
